import { PricePipe } from './../pipes/price.pipe';
import { SplitStringPipe } from './../pipes/split-string.pipe';
import { ModuleListComponent } from './module-list/module-list.component';
import { InputImageComponent } from './fields/input-image/input-image.component';
import { FullNameShorterPipe } from './../pipes/fullNameShorter.pipe';
import { AttachmentSlicePipe } from './../pipes/attachment-slice.pipe';
import { NotificationModule } from './..//apps/notification/notification.module';
import { MediaModule } from './../apps/media/media.module';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ApplicationIndexComponent } from './application-index/application-index.component';
import { NgZorroModule } from '../ng-zorro.module';
import { RouterModule } from '@angular/router';
import { RecordsListComponent } from './records-list/records-list.component';
import { RecordPageComponent } from './record-page/record-page.component';
import {
  GetPullValPipe,
  GetPushValPipe,
  GetSpanValPipe,
  NormalSectionComponent,
} from './sections/normal-section/normal-section.component';
import { LineSectionComponent } from './sections/line-section/line-section.component';
import { InputStringComponent } from './fields/input-string/input-string.component';
import { TextComponent } from './fields/input-text/text.component';
import { InputDateComponent } from './fields/input-date/input-date.component';
import { InputSelectComponent } from './fields/input-select/input-select.component';
import { InputTimeComponent } from './fields/input-time/input-time.component';
import { InputNumberComponent } from './fields/input-number/input-number.component';
import { InputCheckComponent } from './fields/input-check/input-check.component';
import { InputPercentComponent } from './fields/input-percent/input-percent.component';
import { InputQuantityComponent } from './fields/input-quantity/input-quantity.component';
import { InputAmountComponent } from './fields/input-amount/input-amount.component';
import { InputRateComponent } from './fields/input-rate/input-rate.component';
import { InputPriceComponent } from './fields/input-price/input-price.component';
import { InputLinkComponent } from './fields/input-link/input-link.component';
import { ListSectionComponent } from './sections/list-section/list-section.component';
import { InputIntegerComponent } from './fields/input-integer/input-integer.component';
import { TableSectionComponent } from './sections/table-section/table-section.component';
import { CellLabelComponent } from './table-cells/cell-label/cell-label.component';
import { CellCheckboxComponent } from './table-cells/cell-checkbox/cell-checkbox.component';
import { CellSelectComponent } from './table-cells/cell-select/cell-select.component';
import { CellDateComponent } from './table-cells/cell-date/cell-date.component';
import { CellQuantityComponent } from './table-cells/cell-quantity/cell-quantity.component';
import { CellAmountComponent } from './table-cells/cell-amount/cell-amount.component';
import { AppMenuComponent } from './app-menu/app-menu.component';
import { AppSubMenuComponent } from './app-sub-menu/app-sub-menu.component';
import { FieldComponent } from './fields/field/field.component';
import { InputLabelComponent } from './fields/input-label/input-label.component';
import { WizardFilterSectionComponent } from './sections/wizard-filter-section/wizard-filter-section.component';
import { LanguagesListComponent } from './general/languages-list/languages-list.component';
import { AmountPipe } from '../pipes/amount.pipe';
import { ProductImageUrlPipe } from '../pipes/ProductImageUrlPipe.pipe';
import { RecordsListCardsComponent } from './records-list-cards/records-list-cards.component';
import { RecordsListTableComponent } from './records-list-table/records-list-table.component';
import { TimelineSectionComponent } from './sections/timeline-section/timeline-section.component';
import { CellSelectionCheckboxComponent } from './table-cells/cell-selection-checkbox/cell-selection-checkbox.component';
import { InputMapComponent } from './fields/input-map/input-map.component';
import { CellLinkComponent } from './table-cells/cell-link/cell-link.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { InputAttachmentComponent } from './fields/input-attachment/input-attachment.component';
import { CellIconComponent } from './table-cells/cell-icon/cell-icon.component';
import { InputAddressComponent } from './fields/input-address/input-address.component';
import { InputPriceLinesComponent } from './fields/input-price-lines/input-price-lines.component';
import { InputPriceFromDocumentComponent } from './fields/input-price-from-document/input-price-from-document.component';
import { TableSectionContainerComponent } from './table-section-container/table-section-container.component';
import { LinesTemplateSectionComponent } from './sections/lines-template-section/lines-template-section.component';
import { RecordsListKanbanComponent } from './records-list-kanban/records-list-kanban.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RecordsListContainerComponent } from './records-list-container/records-list-container.component';
import { CommunicationComponent } from './communication/communication.component';
import { MinuteSecondsPipe } from '../pipes/minute-seconds.pipe';
import { ShortNamePipe } from '../pipes/short-name.pipe';
import { CommentComponent } from './comment/comment.component';
import { InboundBatchComponent } from './fields/input-quantity/inbound-batch/inbound-batch.component';
import { InboundSerialComponent } from './fields/input-quantity/inbound-serial/inbound-serial.component';
import { InboundBinComponent } from './fields/input-quantity/inbound-bin/inbound-bin.component';
import { OutboundSerialComponent } from './fields/input-quantity/outbound-serial/outbound-serial.component';
import { OutboundBatchComponent } from './fields/input-quantity/outbound-batch/outbound-batch.component';
import { InboxComponent } from './Inbox/Inbox.component';
import { InboxListComponent } from './Inbox/inboxList/inboxList.component';
import { MessageDetailsComponent } from './Inbox/MessageDetails/MessageDetails.component';
import { ComposeEmailComponent } from './Inbox/ComposeEmail/ComposeEmail.component';
import { InboxMessageComponent } from './Inbox/inboxMessage/inboxMessage.component';
import { ActivityComponent } from './Inbox/activity/activity.component';
import { InputHtmlComponent } from './fields/input-html/input-html.component';
import { SearchComponent } from './search/search.component';
import { ActionsComponent } from './record-page/actions/actions.component';
import { CommunicationButtonComponent } from './record-page/communication-button/communication-button.component';
import { ApplicationCompanySwitcherComponent } from './application-company-switcher/application-company-switcher.component';
import { RelationMapComponent } from './relation-map/relation-map.component';
import { CardsComponent } from './sections/line-section/cards/cards.component';
import { LineSectionActionsComponent } from './sections/line-section/line-section-actions/line-section-actions.component';
import {
  ButtonVisiblePipe,
  CustomButtonsComponent,
} from './record-page/custom-buttons/custom-buttons.component';
import { ModuleListNewComponent } from './module-list-new/module-list-new.component';
import { TruncateHtmlPipe } from '../pipes/truncateHtml.pipe';
import { PagesComponent } from './pages/pages.component';
import { ContentBuilderComponent } from './content-builder/content-builder.component';
import { ShoppingListComponent } from './shopping-list/shopping-list.component';
import { LocaleDirective } from '@app/Directives/locale.directive';
import { InputCcValidityComponent } from './fields/input-cc-validity/input-cc-validity.component';
import { CellRichTextComponent } from './table-cells/cell-rich-text/cell-rich-text.component';
import { CartProductsComponent } from '@app/apps/shoppingCart/cartProducts/cartProducts.component';
import { ProductDetailsComponent } from '@app/apps/shoppingCart/cartProducts/product-details/product-details.component';
import { FilterFieldsDateComponent } from './filter-fields/filter-fields-date/filter-fields-date.component';
import { ApprovalDecisionDialogComponent } from './general/approval-decision-dialog/approval-decision-dialog.component';
import { CreationSuccessComponent } from './general/creation-success/creation-success.component';
import { MapValueFromObjectPipe } from '@app/pipes/map-value-from-object.pipe';
import { ScheduleSuggestionsComponent } from './record-page/custom-buttons/schedule-suggestions/schedule-suggestions.component';
import { PriceHistoryComponent } from './record-page/custom-buttons/price-history/price-history.component';
import { AvailableToPromiseComponent } from './record-page/custom-buttons/available-to-promise/available-to-promise.component';
import { LazyLoadDirective } from './directives/lazy-loader.directive';
import { ValueRendererPipe } from './value-renderer.pipe';
import { RecordChangeLogComponent } from './record-page/custom-buttons/record-change-log/record-change-log.component';
import { CompareResultComponent } from './record-page/custom-buttons/record-change-log/compare-result/compare-result.component';
import { ListSubmitSuccessComponent } from './shopping-list/list-submit-success/list-submit-success.component';
import { ParseHandlebarsPipe } from '@app/pipes/parseHandlebars.pipe';
import { AnnouncementModalComponentComponent } from './announcement-modal-component/announcement-modal-component.component';
import { ImportDocItemsComponent } from './sections/data-actions/import-doc-items/import-doc-items.component';
import { WarrentyOptionsComponent } from '@app/apps/shoppingCart/warrenty-options/warrenty-options.component';
import { SNChooserComponent } from '@app/apps/shoppingCart/snchooser/snchooser.component';
import { LineAttachmentsComponent } from './record-page/custom-buttons/line-attachments/line-attachments.component';
import { CellImagesComponent } from './table-cells/cell-images/cell-images.component';
import { OffloadMappingComponent } from './record-page/custom-buttons/offload-mapping/offload-mapping.component';
import { AddVariantsDrawerComponent } from './add-variants/add-variants-drawer.component';
import { WarehouseSelectorComponent } from '@app/apps/shoppingCart/warehouse-selector/warehouse-selector.component';

@NgModule({
  declarations: [
    MapValueFromObjectPipe,
    GetSpanValPipe,
    GetPushValPipe,
    GetPullValPipe,
    SplitStringPipe,
    ParseHandlebarsPipe,
    LocaleDirective,
    ShoppingListComponent,
    ContentBuilderComponent,
    PagesComponent,
    RelationMapComponent,
    FullNameShorterPipe,
    AmountPipe,
    ProductImageUrlPipe,
    AttachmentSlicePipe,
    ButtonVisiblePipe,
    ApplicationIndexComponent,
    RecordsListComponent,
    RecordPageComponent,
    NormalSectionComponent,
    LineSectionComponent,
    LinesTemplateSectionComponent,
    InputStringComponent,
    TextComponent,
    InputDateComponent,
    InputSelectComponent,
    InputTimeComponent,
    InputNumberComponent,
    InputCheckComponent,
    InputPercentComponent,
    InputQuantityComponent,
    InputAmountComponent,
    InputRateComponent,
    InputPriceComponent,
    InputLinkComponent,
    ListSectionComponent,
    InputIntegerComponent,
    TableSectionComponent,
    CellLabelComponent,
    CellCheckboxComponent,
    CellSelectComponent,
    CellDateComponent,
    CellQuantityComponent,
    CellAmountComponent,
    CellRichTextComponent,
    AppMenuComponent,
    AppSubMenuComponent,
    FieldComponent,
    InputLabelComponent,
    WizardFilterSectionComponent,
    LanguagesListComponent,
    RecordsListCardsComponent,
    RecordsListTableComponent,
    TimelineSectionComponent,
    CellSelectionCheckboxComponent,
    InputMapComponent,
    CellLinkComponent,
    PageHeaderComponent,
    InputAttachmentComponent,
    InputCcValidityComponent,
    CellIconComponent,
    InputAddressComponent,
    InputPriceLinesComponent,
    InputPriceFromDocumentComponent,
    TableSectionContainerComponent,
    LinesTemplateSectionComponent,
    RecordsListKanbanComponent,
    RecordsListContainerComponent,
    CommunicationComponent,
    MinuteSecondsPipe,
    ShortNamePipe,
    CommentComponent,
    InboundBatchComponent,
    InboundSerialComponent,
    InboundBinComponent,
    OutboundSerialComponent,
    OutboundBatchComponent,
    InboxComponent,
    InboxListComponent,
    MessageDetailsComponent,
    ComposeEmailComponent,
    InboxMessageComponent,
    ActivityComponent,
    InputHtmlComponent,
    InputImageComponent,
    SearchComponent,
    ActionsComponent,
    CommunicationButtonComponent,
    ApplicationCompanySwitcherComponent,
    // MediaSectionComponent,
    // MediaImageComponent,
    // MediaHolderComponent,
    CardsComponent,
    LineSectionActionsComponent,
    CustomButtonsComponent,
    ModuleListComponent,
    ModuleListNewComponent,
    TruncateHtmlPipe,
    PricePipe,
    InputCcValidityComponent,
    CartProductsComponent,
    WarrentyOptionsComponent,
    ProductDetailsComponent,
    FilterFieldsDateComponent,
    ApprovalDecisionDialogComponent,
    CreationSuccessComponent,
    ScheduleSuggestionsComponent,
    ImportDocItemsComponent,
    PriceHistoryComponent,
    AvailableToPromiseComponent,
    RecordChangeLogComponent,
    LazyLoadDirective,
    ValueRendererPipe,
    CompareResultComponent,
    ListSubmitSuccessComponent,
    AnnouncementModalComponentComponent,
    ImportDocItemsComponent,
    SNChooserComponent,
    WarehouseSelectorComponent,
    LineAttachmentsComponent,
    CellImagesComponent,
    OffloadMappingComponent,
    AddVariantsDrawerComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgZorroModule,
    FormsModule,
    MediaModule,
    DragDropModule,
    ReactiveFormsModule,
    NotificationModule,
  ],
  exports: [
    ProductDetailsComponent,
    CartProductsComponent,
    WarrentyOptionsComponent,
    LocaleDirective,
    FullNameShorterPipe,
    CustomButtonsComponent,
    ScheduleSuggestionsComponent,
    ImportDocItemsComponent,
    PriceHistoryComponent,
    AmountPipe,
    ProductImageUrlPipe,
    ParseHandlebarsPipe,
    ApplicationIndexComponent,
    RecordsListComponent,
    RecordPageComponent,
    NormalSectionComponent,
    LineSectionComponent,
    LinesTemplateSectionComponent,
    InputStringComponent,
    TextComponent,
    InputDateComponent,
    InputSelectComponent,
    InputTimeComponent,
    InputNumberComponent,
    InputCheckComponent,
    InputPercentComponent,
    InputQuantityComponent,
    InputAmountComponent,
    InputRateComponent,
    InputPriceComponent,
    InputLinkComponent,
    ListSectionComponent,
    InputIntegerComponent,
    TableSectionComponent,
    CellLabelComponent,
    CellCheckboxComponent,
    CellSelectComponent,
    CellDateComponent,
    CellQuantityComponent,
    CellAmountComponent,
    CellRichTextComponent,
    FilterFieldsDateComponent,
    WizardFilterSectionComponent,
    LanguagesListComponent,
    CellLinkComponent,
    TimelineSectionComponent,
    TableSectionContainerComponent,
    RecordsListContainerComponent,
    MinuteSecondsPipe,
    ShortNamePipe,
    InboxComponent,
    InboxListComponent,
    MessageDetailsComponent,
    ComposeEmailComponent,
    InboxMessageComponent,
    ActivityComponent,
    InputHtmlComponent,
    InputImageComponent,
    ApplicationCompanySwitcherComponent,
    RelationMapComponent,
    // MediaSectionComponent,
    // MediaImageComponent,
    // MediaHolderComponent,
    ContentBuilderComponent,
    ModuleListComponent,
    SplitStringPipe,
    PricePipe,
    ApprovalDecisionDialogComponent,
    CreationSuccessComponent,
    MapValueFromObjectPipe,
    SNChooserComponent,
    WarehouseSelectorComponent,
    LineAttachmentsComponent,
    OffloadMappingComponent
  ],
  providers: [],
})
export class LayoutModule {}
